<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ sysText.leaveCalendarWarning | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close()" [attr.aria-label]="sysText.close">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <div class="subtitle1">
    <!-- message for hidden or closed case is always shown -->

    @if (caseDetails.isHidden) {
      <p class="body2 dialog-section">{{ sysText.leaveCalendarWarning_hidden_subtitle }}</p>
    }
    @if (!caseDetails.isHidden && caseDetails.isClosed) {
      <p class="body2 dialog-section">{{ sysText.leaveCalendarWarning_closed_subtitle }}</p>
    }

    <!-- message for missing requirements or error conditions (only one shown) -->

    @if (caseDetails.showCalendarOverlayForAdmins && caseDetails.leaveCalendar.missingCalendarRequirements) {
      <p class="body2 dialog-section">{{ sysText.leaveCalendarWarning_subtitle }}</p>
    }
    @if (caseDetails.showCalendarOverlayForAdmins && !caseDetails.leaveCalendar.missingCalendarRequirements && caseDetails.leaveCalendar.hasLeaveHoursErrors) {
      <p class="body2 dialog-section">{{ sysText.leaveCalendarErrors_subtitle }}</p>
    }
  </div>

  @if (caseDetails.showCalendarOverlayForAdmins && (caseDetails.leaveCalendar.missingCalendarRequirements || caseDetails.leaveCalendar.hasLeaveHoursErrors)) {
    <div>
      <!-- anonymous -->
      @if (caseDetails.employeeInformation.isAnonymous) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.employeeRequired }}
        </p>
      }
      @if (!caseDetails.employeeInformation.isAnonymous) {
        <!-- conditions that only apply when an employee is assigned to the case -->
        <!-- case settings missing -->
        @if (caseDetails.leaveInformation.currentStageId > leaveStages.ReadyForLeave) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.onOrAfterReadyForLeave }}
          </p>
        }
        @if (caseDetails.leaveInformation.leaveType == null) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.leaveTypeRequired }}
          </p>
        }
        @if (caseDetails.leaveInformation.startDate == null) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.startDateRequired }}
          </p>
        }
        @if (caseDetails.leaveInformation.endDate == null) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.endDateRequired }}
          </p>
        }
        <!-- employee settings missing -->
        @if (caseDetails.leaveCalendar.missingWorkSchedule) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.workScheduleRequired }}
          </p>
        }
        @if (caseDetails.leaveCalendar.missingDateOfHire) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.dateOfHireRequired }}
          </p>
        }
        @if (caseDetails.leaveCalendar.missingWorkingInState) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.workingInStateRequired }}
          </p>
        }
        @if (caseDetails.leaveInformation.isBank1EntitlementMissing) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.bankTotalHoursRequired?.replace("@[bank]", caseDetails.leaveHoursBanksBuckets.bank1Name ?? caseDetails.leaveHoursBanksBuckets.bank1DefaultName) }}
          </p>
        }
        @if (caseDetails.leaveInformation.isBank2EntitlementMissing) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.bankTotalHoursRequired?.replace("@[bank]", caseDetails.leaveHoursBanksBuckets.bank2Name ?? caseDetails.leaveHoursBanksBuckets.bank2DefaultName) }}
          </p>
        }
        @if (caseDetails.leaveInformation.isBank3EntitlementMissing) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.bankTotalHoursRequired?.replace("@[bank]", caseDetails.leaveHoursBanksBuckets.bank3Name ?? caseDetails.leaveHoursBanksBuckets.bank3DefaultName) }}
          </p>
        }
        @if (caseDetails.leaveInformation.isBank4EntitlementMissing) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.bankTotalHoursRequired?.replace("@[bank]", caseDetails.leaveHoursBanksBuckets.bank4Name ?? caseDetails.leaveHoursBanksBuckets.bank4DefaultName) }}
          </p>
        }
        @if (caseDetails.leaveInformation.isBank5EntitlementMissing) {
          <p class="body2">
            <span class="bullet-space">&bull;</span>{{ sysText.bankTotalHoursRequired?.replace("@[bank]", caseDetails.leaveHoursBanksBuckets.bank5Name ?? caseDetails.leaveHoursBanksBuckets.bank5DefaultName) }}
          </p>
        }
      }
      @if (caseDetails.leaveCalendar.malformedEmployerLeaveYearRules) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.malformedEmployerLeaveYearRules }}
        </p>
      }
      @if (caseDetails.leaveCalendar.missingBank1LeaveYear) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.bankLeaveYearRequired?.replace("@[bank]", caseDetails.leaveHoursBanksBuckets.bank1Name ?? caseDetails.leaveHoursBanksBuckets.bank1DefaultName) }}
        </p>
      }
      @if (caseDetails.leaveCalendar.missingBank2LeaveYear) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.bankLeaveYearRequired?.replace("@[bank]", caseDetails.leaveHoursBanksBuckets.bank2Name ?? caseDetails.leaveHoursBanksBuckets.bank2DefaultName) }}
        </p>
      }
      @if (caseDetails.leaveCalendar.missingBank3LeaveYear) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.bankLeaveYearRequired?.replace("@[bank]", caseDetails.leaveHoursBanksBuckets.bank3Name ?? caseDetails.leaveHoursBanksBuckets.bank3DefaultName) }}
        </p>
      }
      @if (caseDetails.leaveCalendar.missingBank4LeaveYear) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.bankLeaveYearRequired?.replace("@[bank]", caseDetails.leaveHoursBanksBuckets.bank4Name ?? caseDetails.leaveHoursBanksBuckets.bank4DefaultName) }}
        </p>
      }
      @if (caseDetails.leaveCalendar.missingBank5LeaveYear) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.bankLeaveYearRequired?.replace("@[bank]", caseDetails.leaveHoursBanksBuckets.bank5Name ?? caseDetails.leaveHoursBanksBuckets.bank5DefaultName) }}
        </p>
      }
      @if (caseDetails.leaveCalendar.missingFixedStart) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.fixedStartRequired }}
        </p>
      }
      <!-- leave hours error conditions -->
      @if (caseDetails.leaveCalendar.leavesOutsideCaseTimeframe) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.leavesOutsideCaseTimeframe }}
        </p>
      }
      @if (caseDetails.leaveCalendar.leavesOnNonWorkdays) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.leavesOnNonWorkdays }}
        </p>
      }
      @if (caseDetails.leaveCalendar.leavesExceedWorkdayHours) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.leavesExceedWorkdayHours }}
        </p>
      }
      @if (caseDetails.leaveCalendar.leavesNotFullDayIncrement) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ sysText.leavesNotFullDayIncrement }}
        </p>
      }
    </div>
  }
</mat-dialog-content>

@if (!(isMobile$ | async)) {
  <mat-dialog-actions align="end">
    <button mat-stroked-button class="button" [mat-dialog-close]="true" color="accent">
      {{ sysText.close }}
    </button>
  </mat-dialog-actions>
}
